import { useQuery } from "react-query";
import { ChampionshipAPI } from "api/admin/championship";
import { CHAMPIONSHIPS } from "helpers/constants";

export default function useCompetitionEvent(id) {
  return useQuery([CHAMPIONSHIPS, id], () =>
    ChampionshipAPI.getAllForCompetition(id)
  );
}
